import React from 'react'

const Homepricing = () => {

  

  return (
    <section id="pricing" className="pricing section">
      {/* Section Title */}
      <div className="container section-title">
        <h2>Simple and Transparent Pricing</h2>
        <p>Awesome doesn’t have to be expensive</p>
      </div>{/* End Section Title */}
      <div className="container">
        <div className="row gy-4">
          <div className="col-lg-3">
            <div className="pricing-item">
              <h3>Free Trial</h3>
              <p className="description">Explore the application for 7 days No Credit Card details required*</p>
              <h4>₹0<span> / month</span></h4>
              <a href="http://127.0.0.1:8000/user/register" className="cta-btn">Start a free trial</a>
              <p className="text-center small mt-2">(Including 70 employees)</p>
              <p className="text-center small mt-2">₹0<span> / additional employee</span></p>
              <ul>
                <li><i className="bi bi-check" /> <span>CoreHr</span></li>
                <li><i className="bi bi-check" /> <span>Attendence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Payroll</span></li>
                <li><i className="bi bi-check" /> <span>Leave Managements</span></li>
                <li><i className="bi bi-check" /> <span>Performence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Hr Managements</span></li>
                <li><i className="bi bi-check" /> <span>Reminders and Alerts</span></li>
                <li><i className="bi bi-check" /> <span>Project managaments</span></li>
                <li><i className="bi bi-check" /> <span>Training and Developments(LMS)</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Extensive Excel import &amp; Export Facility</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Reports</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Support Plans</span></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="pricing-item">
              <h3>Starter</h3>
              <p className="description">For companies that are just getting started with automation</p>
              <h4>₹2000<span> / month</span></h4>
              <a href="http://127.0.0.1:8000/user/register" className="cta-btn">Start a free trial</a>
              <p className="text-center small mt-2">(Including 70 employees)</p>
              <p className="text-center small mt-2">₹50<span> / additional employee</span></p>
              <ul>
                <li><i className="bi bi-check" /> <span>CoreHr</span></li>
                <li><i className="bi bi-check" /> <span>Attendence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Payroll</span></li>
                <li><i className="bi bi-check" /> <span>Leave Managements</span></li>
                <li><i className="bi bi-check" /> <span>Performence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Hr Managements</span></li>
                <li><i className="bi bi-check" /> <span>Reminders and Alerts</span></li>
                <li><i className="bi bi-check" /> <span>Project managaments</span></li>
                <li><i className="bi bi-check" /> <span>Training and Developments(LMS)</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Extensive Excel import &amp; Export Facility</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Reports</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Support Plans</span></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="pricing-item">
              <h3>Professional</h3>
              <p className="description">Scaling with advanced automation &amp; employee engagement</p>
              <h4>₹2500<span> / month</span></h4>
              <a href="http://127.0.0.1:8000/user/register" className="cta-btn">Start a free trial</a>
              <p className="text-center small mt-2">(Including 70 employees)</p>
              <p className="text-center small mt-2">₹50<span> / additional employee</span></p>
              <ul>
                <li><i className="bi bi-check" /> <span>CoreHr</span></li>
                <li><i className="bi bi-check" /> <span>Attendence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Payroll</span></li>
                <li><i className="bi bi-check" /> <span>Leave Managements</span></li>
                <li><i className="bi bi-check" /> <span>Performence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Hr Managements</span></li>
                <li><i className="bi bi-check" /> <span>Reminders and Alerts</span></li>
                <li><i className="bi bi-check" /> <span>Project managaments</span></li>
                <li><i className="bi bi-check" /> <span>Training and Developments(LMS)</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Extensive Excel import &amp; Export Facility</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Reports</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Support Plans</span></li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="pricing-item">
              <h3>Enterprise</h3>
              <p className="description">Comprehensive plan designed to engage employees and take your organization to new heights.</p>
              <h4>₹4000<span> / month</span></h4>
              <a href="http://127.0.0.1:8000/user/register" className="cta-btn">Start a free trial</a>
              <p className="text-center small mt-2">(Including 70 employees)</p>
              <p className="text-center small mt-2">₹100<span> / additional employee</span></p>
              <ul>
                <li><i className="bi bi-check" /> <span>CoreHr</span></li>
                <li><i className="bi bi-check" /> <span>Attendence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Payroll</span></li>
                <li><i className="bi bi-check" /> <span>Leave Managements</span></li>
                <li><i className="bi bi-check" /> <span>Performence Managements</span></li>
                <li><i className="bi bi-check" /> <span>Hr Managements</span></li>
                <li><i className="bi bi-check" /> <span>Reminders and Alerts</span></li>
                <li><i className="bi bi-check" /> <span>Project managaments</span></li>
                <li><i className="bi bi-check" /> <span>Training and Developments(LMS)</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Extensive Excel import &amp; Export Facility</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Reports</span></li>
                <li className="na"><i className="bi bi-x" /> <span>Support Plans</span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

  )
}

export default Homepricing
